import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import Alert from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'
import { usePage } from '@inertiajs/react'

interface Props {
  title: string
  children: React.ReactNode
}

export function AuthLayout({ title, children }: Props) {
  const { flash } = usePage().props
  const [noticeOpen, setNoticeOpen] = useState(!!flash?.notice)
  const [alertOpen, setAlertOpen] = useState(!!flash?.alert)

  useEffect(() => { setNoticeOpen(!!flash?.notice) }, [flash?.notice])
  useEffect(() => { setAlertOpen(!!flash?.alert) }, [flash?.alert])

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'background.default',
        py: 4,
      }}
    >
      <Container maxWidth="sm">
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography variant="h4" component="h1" fontWeight={700} sx={{ letterSpacing: '-0.03em' }}>
            Okonomi OS
          </Typography>
        </Box>
        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, sm: 5 },
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 2,
          }}
        >
          <Typography variant="h2" component="h2" sx={{ mb: 3 }}>
            {title}
          </Typography>
          {children}
        </Paper>
      </Container>
      <Snackbar
        open={noticeOpen && !!flash?.notice}
        autoHideDuration={5000}
        onClose={(_e, reason) => { if (reason !== 'clickaway') setNoticeOpen(false) }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert severity="success" onClose={() => setNoticeOpen(false)} variant="filled">
          {flash?.notice}
        </Alert>
      </Snackbar>
      <Snackbar
        open={alertOpen && !!flash?.alert}
        autoHideDuration={8000}
        onClose={(_e, reason) => { if (reason !== 'clickaway') setAlertOpen(false) }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert severity="error" onClose={() => setAlertOpen(false)} variant="filled">
          {flash?.alert}
        </Alert>
      </Snackbar>
    </Box>
  )
}
